import { render } from "./MainMenuItem.vue?vue&type=template&id=04266186"
import script from "./MainMenuItem.vue?vue&type=script&lang=js"
export * from "./MainMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__